module.exports = __webpack_public_path__ + "img/antes_despues_292.17f090b2.png";